

var finalLink = '';
$('#birthForm .btn').click(function(e){
  e.preventDefault();
  var lang = $('body').attr('data-lang'),
      yearValue = $('#birthYear').val(),
      countryValue = $('#birthCountry').val();

  if (lang == 'fr') var initLink = '/fr/search?sortBy=products_en&refinementList%5BisSold%5D%5B0%5D=false'
  else var initLink = '/search?sortBy=products_en&refinementList%5BisSold%5D%5B0%5D=false';

  if(!$('#birthYear').val()) {
    $('#birthYear').parents('.form-group').addClass('has-error');
  } else {

    if (lang == 'fr') {
      $('#birthYear').parents('.form-group').removeClass('has-error');
      if ($('#yes').is(":checked")) {
        finalLink = initLink + '&refinementList%5Bcaracteristics.fr.29%5D%5B0%5D=' + yearValue + '&refinementList%5Bcaracteristics.fr.42%5D%5B0%5D=Argent&refinementList%5Bcaracteristics.fr.42%5D%5B1%5D=Or&refinementList%5Bcaracteristics.fr.42%5D%5B2%5D=Vermeil&refinementList%5Bcaracteristics.fr.42%5D%5B3%5D=Electrum&q=' + countryValue + '%20-Jetons%20-Médailles%20-Billets%20-Nécessité%20-Decorations%20-Antiques#results';
      } else {
        finalLink = initLink + '&refinementList%5Bcaracteristics.fr.29%5D%5B0%5D=' + yearValue + '&q=' + countryValue + '%20-Jetons%20-Médailles%20-Billets%20-Nécessité%20-Decorations%20-Antiques#results';     
      }
    } else {
      $('#birthYear').parents('.form-group').removeClass('has-error');
        if ($('#yes').is(":checked")) {
          finalLink = initLink + '&refinementList%5Bcaracteristics.en.29%5D%5B0%5D=' + yearValue + '&refinementList%5Bcaracteristics.en.42%5D%5B0%5D=Silver&refinementList%5Bcaracteristics.en.42%5D%5B1%5D=Gold&refinementList%5Bcaracteristics.en.42%5D%5B2%5D=Argent&refinementList%5Bcaracteristics.en.42%5D%5B3%5D=Electrum&refinementList%5Bcaracteristics.en.42%5D%5B4%5D=Gold%20And%20Silver&refinementList%5Bcaracteristics.en.42%5D%5B5%5D=Platinum&refinementList%5Bcaracteristics.en.42%5D%5B6%5D=Red%20Gold&q=' + countryValue + '%20-Tokens%20-Medals%20-Banknotes%20-Necessity%20-Decorations%20-Antique#results';
        } else {
          finalLink = initLink + '&refinementList%5Bcaracteristics.en.29%5D%5B0%5D=' + yearValue + '&q=' + countryValue + '%20-Tokens%20-Medals%20-Banknotes%20-Necessity%20-Decorations%20-Antique#results';     
        }
    }  

    //window.location.href = finalLink;
    window.open(finalLink, '_blank');
  }  
});

